/* eslint-disable no-bitwise */
const Moment = require('moment');

const PERCENT_OFFSET = 20;
const MAX_PERCENT = 100 - PERCENT_OFFSET;
const DEFAULT_MIN = 100;
const DEFAULT_MAX = 160;

function checkIsNan(value) {
  return Number.isNaN(value) || value === 'NaN';
}

function getOffset(timeRange, timeOffset, startTime) {
  let newTime = Moment(startTime, 'L');
  if (timeOffset === -1) {
    newTime = Moment(startTime, 'L').subtract(1, timeRange).startOf(timeRange);
  }
  if (timeOffset === 1) {
    newTime = Moment(startTime, 'L').add(1, timeRange).startOf(timeRange);
  }
  return new Date(newTime.toDate());
}

function lighten(color, amount) {
  if (!color) return null;
  const num = parseInt(color.replace('#', ''), 16);

  let red = (num >> 16) + amount;

  if (red > 255) red = 255;
  else if (red <= 0) red = 0;

  let blue = ((num >> 8) & 0x00FF) + amount;

  if (blue > 255) blue = 255;
  else if (blue <= 0) blue = 0;

  let green = (num & 0x0000FF) + amount;

  if (green > 255) green = 255;
  else if (green <= 0) green = 0;

  return `#${((green | (blue << 8) | (red << 16)).toString(16)).padStart(6, '0')}`;
}

function number(_value, base) {
  const value = checkIsNan(_value) ? 0 : _value;
  const parsed = Number.parseFloat(value).toFixed(base);
  return checkIsNan(parsed) ? 0 : parsed;
}

function percent2setpoint(input, opts) {
  let percent = input;
  const max = opts.limits[1] || DEFAULT_MAX;
  const min = opts.limits[0] || DEFAULT_MIN;
  if (percent < PERCENT_OFFSET) {
    return opts.off || min;
  }
  percent -= PERCENT_OFFSET;
  return Math.round(min + (percent / MAX_PERCENT) * (max - min));
}

function percent2timeOfDay(input) {
  let percent = input;
  if (percent < PERCENT_OFFSET) {
    return null;
  }
  percent -= PERCENT_OFFSET;
  const tod = Math.round((4 + (percent / MAX_PERCENT) * 24) * 1000) / 1000;
  return tod >= 24 ? tod - 24 : tod;
}

function roundAxis(value, type, opts) {
  const { gap = 0, base = 0, override } = opts;
  const parsed = number(value, base);
  const rounded = Number.isInteger(parsed) ? Math.round(parsed) : Number(parsed);
  let num;

  switch (type) {
    case 'max':
      num = override !== undefined && override > rounded ? override : rounded;
      num += gap;
      return num >= value ? num : num + 1;
    case 'min':
      num = override !== undefined && override < rounded ? override : rounded;
      num -= gap;
      return num <= value ? num : num - 1;
    default:
      return rounded;
  }
}

function setpoint2percent(setpoint, opts) {
  const max = opts.limits[1] || DEFAULT_MAX;
  const min = opts.limits[0] || DEFAULT_MIN;
  if (setpoint < min) {
    return 0;
  }
  return PERCENT_OFFSET + ((MAX_PERCENT * (setpoint - min)) / (max - min));
}

function timeOfDay2percent(tod) {
  if (tod == null) {
    return 0;
  }
  const percent = (MAX_PERCENT * (tod - 4)) / 24;
  return PERCENT_OFFSET + (percent < 0 ? percent + MAX_PERCENT : percent);
}

function updateLength(devices, filterBy) {
  if (!devices) { return []; }
  return devices.filter((device) => {
    const now = Moment(new Date());
    const numDays = now.diff(device.updateStatus, 'days');
    return (
      (filterBy === 'Over 1 day' && numDays >= 1)
        || (filterBy === 'Over 2 days' && numDays > 2)
        || (filterBy === 'Over 1 week' && numDays > 7)
        || (filterBy === 'Over 1 month' && numDays > 30)
        || (filterBy === '__null__')
    );
  });
}

function withinWindow(start, end, data) {
  const startMs = start.setHours(0, 0, 0, 0);
  const endMs = end.setHours(0, 0, 0, 0);
  const filteredData = start !== undefined && end !== undefined ? data.filter((dataPoint) => {
    const dataPointMs = Date.parse(dataPoint.x);
    return dataPointMs >= startMs && dataPointMs <= endMs;
  }) : data;
  return filteredData;
}

function stringToValue(string) {
  if (!string || typeof string !== 'string') return string;
  // String to Number
  if (!Number.isNaN(Number(string))) return Number(string);
  
  const stringLowerCased = string.toLowerCase();
  // String to Boolean
  if (stringLowerCased === 'true' || stringLowerCased === 'false') return stringLowerCased === 'true';
  // String to Null
  if (stringLowerCased === 'null') return null;
  
  // default to string
  return string;
}

module.exports = {
  checkIsNan,
  // eslint-disable-next-line no-unused-vars
  fromNow: (value, test = null) => (value ? Moment(value).fromNow() : Moment().fromNow()),
  getOffset: (timeRange = 'day', timeOffset = 0, startTime = new Date()) => getOffset(timeRange, timeOffset, startTime),
  lighten,
  number: (value = 0, base = 0) => number(value, base),
  percent2setpoint,
  percent2timeOfDay,
  roundAxis: (value = 0, type = '', opts = {}) => roundAxis(value, type, opts),
  setpoint2percent,
  timeOfDay2percent,
  updateLength,
  withinWindow,
  stringToValue,
};
